import awsClient from '@/shared/http/aws-client';

class AwsAiService {
  getAiResponse(data) {
    return awsClient.post('/ai_response', data);
  }
  getAllFolders() {
    return awsClient.get('/s3/get_all_folders');
  }
  getAllFiles(param) {
    return awsClient.get(`/s3/get_all_files?path=${param}`);
  }
  createNewFolder(data) {
    return awsClient.post('/s3/create_new_folder', data);
  }
  uploadFiles(data) {
    return awsClient.post('/s3/upload_files', data);
  }
  uploadFolder(data) {
    return awsClient.post('/s3/upload_folder', data);
  }
  generatePresignedURL(param) {
    return awsClient.get(`/s3/generate_presigned_url?key=${param}`);
  }
  shareChat(data) {
    return awsClient.post('/chat', data);
  }
  retrieveChat(param) {
    return awsClient.get(`/chat?chat_id=${param}`);
  }
  generateYoutubeLinks(data) {
    return awsClient.post('/youtube/generate', data);
  }
  generateWisbotWidgetResponse(data) {
    return awsClient.post('/wisbot', data);
  }
}

export default new AwsAiService();
